<template>
  <div class="admissionsUser">
    <el-card shadow="always">
      <div class="content_box">
        <div class="title">销售话术系统</div>
        <div class="search_box">
          <div class="input_box" ref="main">
            <el-input
              size="medium"
              clearable
              placeholder="搜索问题"
              v-model="formInline.question"
            >
              <template slot="append">
                <div
                  v-if="!questionShow"
                  @click="questionShow = true"
                  class="icon_box"
                >
                  <i class="el-icon-arrow-down"></i>
                </div>
                <div v-else @click="questionShow = false" class="icon_box">
                  <i class="el-icon-arrow-up"></i>
                </div>
              </template>
            </el-input>
            <div
              class="questionDown_box"
              v-if="questionShow && referralsData.length > 0"
            >
              <p
                v-for="item in referralsData"
                :key="item.id"
                @click="questionClick(item)"
              >
                {{ item.question }}
              </p>
            </div>
          </div>

          <el-button
            size="medium"
            type="primary"
            style="margin-left: 12px"
            @click="handleSearch"
            >搜索</el-button
          >
          <el-button size="medium" @click="handleReset">重置</el-button>
        </div>
        <div>
          <el-tabs
            v-model="formInline.speechcraftClassifyId"
            @tab-click="handleTabClick"
          >
            <el-tab-pane
              v-for="item in speechcraftClassifyData"
              :key="item.id"
              :label="item.name"
              :name="item.id"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="collapse_box">
          <template v-if="cmsSpeechcraftData.length > 0">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item
                v-for="(item, index) in cmsSpeechcraftData"
                :key="item.id"
                :title="index + 1 + '、' + item.question"
                :name="item.id"
              >
                <div class="collapse_item_box">
                  <div class="lef">{{ item.answer }}</div>
                  <el-button
                    size="small"
                    type="primary"
                    @click="duplication(item)"
                    >复制</el-button
                  >
                </div>
              </el-collapse-item>
            </el-collapse>
          </template>
          <template v-else>
            <el-empty description="暂无数据"></el-empty>
          </template>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getCmsSpeechcraftListPage,
  getSpeechcraftClassifyListPage,
} from "@/api/marketingAdmin/technicalDialogue.js";
import Copy from "copy-to-clipboard";
import { clone } from "@/utils/handle.js";
export default {
  data() {
    return {
      activeName: "",
      formInline: {
        question: "",
        speechcraftClassifyId: "",
      },
      referralsData: [],
      cmsSpeechcraftData: [],
      speechcraftClassifyData: [],
      questionShow: false,
      searchData: {},
    };
  },
  created() {
    this.referralsList();
    this.getSpeechcraftClassifyListPage({ page: 1, limit: -1 });
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    // 搜索
    handleSearch() {
      this.searchData = clone(this.formInline);
      this.getCmsSpeechcraftListPage({ ...this.formInline });
    },
    // 重置
    handleReset() {
      this.formInline.question = "";
      this.searchData.question = "";
      this.getCmsSpeechcraftListPage({ ...this.formInline });
    },
    // 点击已推荐列表
    questionClick(payload) {
      this.formInline.question = payload.question;
      this.questionShow = false;
    },
    // 复制
    duplication(payload) {
      Copy(payload.answer);
      this.$message({
        type: "success",
        message: "复制成功!",
      });
    },
    // 点击tab
    handleTabClick() {
      let data = {
        question: this.searchData.question,
        speechcraftClassifyId: this.formInline.speechcraftClassifyId,
      };
      this.getCmsSpeechcraftListPage({ ...data });
    },
    // 话术分类列表
    async getSpeechcraftClassifyListPage() {
      const res = await getSpeechcraftClassifyListPage({ page: 1, limit: -1 });
      this.speechcraftClassifyData = res.data?.records || [];
      if (this.speechcraftClassifyData.length > 0) {
        this.formInline.speechcraftClassifyId =
          this.speechcraftClassifyData[0].id;
      }
      this.getCmsSpeechcraftListPage({ ...this.formInline });
    },
    // 招生话术列表
    async getCmsSpeechcraftListPage(payload) {
      const res = await getCmsSpeechcraftListPage({
        ...payload,
        page: 1,
        limit: -1,
        isRecommend: 1
      });
      this.cmsSpeechcraftData = res.data?.records || [];
    },
    // 已推荐话术
    async referralsList() {
      const res = await getCmsSpeechcraftListPage({
        isRecommend: 1,
        page: 1,
        limit: -1,
      });
      this.referralsData = res.data?.records || [];
    },
    bodyCloseMenus(e) {
      let self = this;
      if (this.$refs.main && !this.$refs.main.contains(e.target)) {
        if (self.questionShow === true) {
          self.questionShow = false;
        }
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.bodyCloseMenus);
  },
};
</script>

<style lang="scss" scoped>
.admissionsUser {
  .content_box {
    min-height: calc(100vh - 190px);
  }
  .title {
    font-size: 20px;
    font-weight: bold;
  }
  .search_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 40px;

    ::v-deep {
      .el-input-group__append {
        padding: 0;
      }
    }

    .input_box {
      width: 100%;
      position: relative;
      .icon_box {
        padding: 0 20px;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
    .questionDown_box {
      width: 100%;
      max-height: 300px;
      overflow: auto;
      background-color: #ffffff;
      border: 1px solid #e9e9e9;
      border-radius: 4px;
      position: absolute;
      top: 38px;
      left: 0;
      z-index: 999;
      padding: 8px 0;
      box-sizing: border-box;
      p {
        text-align: center;
        font-size: 16px;
        padding: 6px 0;
        box-sizing: border-box;
        cursor: pointer;
      }
      p:hover {
        background-color: #f2f2f2;
      }
    }
  }
  .collapse_box {
    border: 1px solid #e9e9e9;
    border-radius: 4px;
    ::v-deep {
      .el-collapse-item__header {
        background-color: #f2f2f2;
        padding-left: 12px;
        border-bottom: 1px solid #f9f9f9;
        box-sizing: border-box;
        height: auto;
        line-height: normal;
        padding-top: 10px;
        padding-bottom: 10px;
      }
      .el-collapse-item__content {
        padding: 14px 12px;
        box-sizing: border-box;
      }
    }
    .collapse_item_box {
      display: flex;
      align-items: center;
      .lef {
        flex: 1;
      }
    }
  }
}
</style>